import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import util from './utils'
import Element from 'element-ui'
import VueParticles from 'vue-particles'
import http from '@/utils/http'
import './permission'
import './icons'
import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/index.scss'

Vue.prototype.$http = http
Vue.prototype.$util = util

Vue.use(Element)
Vue.use(VueParticles)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
